window.addEventListener('load', () => {
  setSize();
  setTimeout(function(){
    $('#loading p').fadeIn(1000);
    setTimeout(function(){
      $('#loading').fadeOut(1500);
    },1500);
    $('#character').scrollTop(0);
  },100);
  showPopup();
});

window.addEventListener('resize', () => {
  setSize();
});


// nav
$('.st-Header_Hamburger').on('click', function(){
  $('.st-Header_Navi').addClass('opened');
});
$('.st-Header_Navi-Close, .st-Header_Navi-List li').on('click', function(){
  $('.st-Header_Navi').removeClass('opened');
});


// pagepiling
$('#pagepiling').pagepiling({
  menu: '#nav',
  sectionSelector: '.section',
  sectionsColor: ['#aaa','#bbb', '#ccc', '#ddd', '#fff', '#aaa'],
  anchors: ['visual', 'news', 'story', 'character', 'movie', 'music', 'sns'],
  navigation: {
    'textColor': '#fff',
    'bulletsColor': '#fff',
    'position': 'right',
    'tooltips': ['VISUAL', 'NEWS', 'STORY', 'CHARACTER', 'MOVIE', 'MUSIC', 'SNS']
  },
  touchSensitivity: 1,
  afterRender: function(){

    if($('#visual').hasClass('active')){
      $('.st-Footer svg .cls-1').css({
        "fill": "#888"
      });
    }

    // // playing the video
    // $('video').get(0).play();

    // slick
    $('.character-List').slick({
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      adaptiveHeight: false,
      appendArrows: $('.character-List'),
      responsive: [{
        breakpoint: 1025, //767px以下のサイズに適用
        settings: {
          appendArrows: $('.st-Footer'),
        }
      }
     ]
    });
    $('.character-Bg').slick({
      dots: false,
      infinite: false,
      speed: 500,
      fade: true,
      arrows: false,
      slidesToShow: 1,
    });

    // slick 連動
    // character on/off
    var current;
    $('.character-List').on('beforeChange', function(event, slick, currentSlide, nextSlide){
       current = nextSlide;
       $('.character-Bg').slick('slickGoTo', parseInt(current));
       $('.slick-active').find('.visual').removeClass('active');

       setTimeout(function(){
         $('.slick-active').find('.visual').addClass('active');
       },100);
    });
    $('.character-List').on('afterChange', function(event, slick, currentSlide, nextSlide){
      $('#character').animate({
        scrollTop: 0
      }, 300);
    });
  },
  onLeave: function(index, nextIndex, direction){
    // kv footer
    if(nextIndex == 1){
      $('.st-Footer svg .cls-1').css({
        "fill": "#888"
      });
    }else if(nextIndex !== 1){
      $('.st-Footer svg .cls-1').css({
        "fill": "#fff"
      });
    }
    // character on/off
    if(nextIndex == 4){
      $('.slick-active').find('.visual').addClass('active');
      $('.slick-prev,.slick-next').addClass('active');
    }else if(nextIndex !== 4){
      setTimeout(function(){
        $('#character').scrollTop(0);
      },1000);
      $('.slick-active').find('.visual').removeClass('active');
      $('.slick-prev,.slick-next').removeClass('active');
    }
  }
});

//YouTubeのモーダル
const youtubeModal = () => {
  const $modal = $('.sw-Movie');
  const $content = $('.sw-Movie_Content');
  const $youtube = $('.js-Youtube');
  // open
  $youtube.on('click', function(){
    $(this).blur();
    const dataID = $(this).attr('data-youtube');
    //iframe append
    $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/'+dataID+'?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
    // fadeIn
    $modal.stop().fadeIn(400);
    return false;
  });
  //close
  $('.sw-Movie_Overlay,.sw-Movie_Close').on('click', function(){
    $modal.stop().fadeOut(400, function(){
      $content.children().remove();
    });
  });
};
youtubeModal();


//スライダー
const slider = () => {
  $('.music-Slider').each(function(){
    $(this).slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
  });
};
$(document).ready(function(){
  slider();
});

const newsChange = () => {
  const $switch = $('.js-News_Tab');
  $switch.find('li').click(function () {
    const index = $('.js-News_Tab ul li').index(this);
    const $target = $switch.siblings('.js-News_List');
    $target.children('div.list').css('display', 'none');
    $target.children('div.list').eq(index).fadeIn(1000);
    $('.js-News_Tab ul li').removeClass('current');
    $(this).addClass('current');
  });
};
newsChange();

// ------------------------------------------------------------------------
// showPopup
// ----- BOTH
// ------------------------------------------------------------------------
const showPopup = () => {

  // open
  $('#popup-Image').css({'opacity':'0','display':'block'}).stop().animate({'opacity':'1','width':100+'%','height':100+'%','top':0,'left':0},500,'easeOutQuart',function(){

    return false;

  });


  //close
  $('#popup-Bg,#popup-Close').on('click', function(){

    $('#popup-Image').css({'opacity':'1'}).stop().animate({'opacity':'0'},300,'easeOutQuart',function(){
      $('#popup-Image').css({'display':'none'});
		});

  });

};
showPopup();

import {setSize} from "../include/module";



// WEBPACK FOOTER //
// ./src/assets/js/index/script.js